const BACKEND = 'https://nexus360-platform-backend-api-production.up.railway.app';

export const SHEETS_API_URL     = `${BACKEND}/api/incidents`;
export const SHEETS_SUBMIT_URL  = import.meta.env.VITE_SHEETS_API_URL || '';

export const REGIONS = [
  'Adamaoua','Centre','Est','Extrême-Nord',
  'Littoral','Nord','Nord-Ouest','Ouest','Sud','Sud-Ouest',
];

export const CITIES: Record<string, string[]> = {
  'Adamaoua':     ['Ngaoundéré','Meiganga','Tibati','Tignère','Banyo','Ngaoundal'],
  'Centre':       ['Yaoundé','Mbalmayo','Obala','Bafia','Nanga-Eboko','Monatélé'],
  'Est':          ['Bertoua','Batouri','Abong-Mbang','Yokadouma','Doumé','Dimako'],
  'Extrême-Nord': ['Maroua','Kousséri','Mora','Yagoua','Mokolo','Guider'],
  'Littoral':     ['Douala','Nkongsamba','Edéa','Mbanga','Loum','Yabassi'],
  'Nord':         ['Garoua','Guider','Figuil','Poli','Tcholliré','Rey-Bouba'],
  'Nord-Ouest':   ['Bamenda','Kumbo','Wum','Nkambe','Fundong','Ndop'],
  'Ouest':        ['Bafoussam','Dschang','Foumban','Mbouda','Bangangté','Baham'],
  'Sud':          ['Ebolowa','Kribi','Sangmélima','Ambam','Lolodorf','Mvangan'],
  'Sud-Ouest':    ['Buea','Limbe','Kumba','Tiko','Mundemba','Mamfe'],
};

export const INCIDENT_TYPES = [
  'Accident de la circulation','Agression physique','Vol avec violence',
  'Enlèvement et séquestration','Terrorisme et extrémisme','Cybercriminalité',
  'Trafic de personnes','Perturbation de l\'ordre public','Homicide',
  'Port illégal d\'armes','Violence domestique','Fraude et escroquerie',
  'Vandalisme','Trafic de stupéfiants','Incendie criminel','Braquage',
  'Cambriolage','Émeute et troubles civils',
];

export const PRECINCTS = [
  'Brigade Anti-Criminalité','Brigade de Gendarmerie','Brigade Mobile',
  'Brigade de Recherches','Commissariat Central','Commissariat d\'Arrondissement',
  'Commissariat Régional','Poste de Police','Unité Spéciale d\'Intervention',
  'Brigade Anti-Terrorisme',
];

export const SEVERITY_LEVELS = [
  { value: '1', label: 'P1 — Critique',  color: 'text-red-400',    bg: 'bg-red-500/10',    border: 'border-red-500/30'    },
  { value: '2', label: 'P2 — Élevé',     color: 'text-orange-400', bg: 'bg-orange-500/10', border: 'border-orange-500/30' },
  { value: '3', label: 'P3 — Moyen',     color: 'text-yellow-400', bg: 'bg-yellow-500/10', border: 'border-yellow-500/30' },
  { value: '4', label: 'P4 — Faible',    color: 'text-green-400',  bg: 'bg-green-500/10',  border: 'border-green-500/30'  },
  { value: '5', label: 'P5 — Mineur',    color: 'text-blue-400',   bg: 'bg-blue-500/10',   border: 'border-blue-500/30'   },
];

export const STATUS_OPTIONS = [
  'Ouvert','En cours','En attente de validation','Résolu','Clôturé',
];

export const STATUS_CONFIG: Record<string, { label: string; color: string; bg: string }> = {
  'Ouvert':                   { label: 'Ouvert',                   color: 'text-blue-400',   bg: 'bg-blue-500/10'   },
  'En cours':                 { label: 'En cours',                 color: 'text-orange-400', bg: 'bg-orange-500/10' },
  'En attente de validation': { label: 'En attente de validation', color: 'text-yellow-400', bg: 'bg-yellow-500/10' },
  'Résolu':                   { label: 'Résolu',                   color: 'text-green-400',  bg: 'bg-green-500/10'  },
  'Clôturé':                  { label: 'Clôturé',                  color: 'text-gray-400',   bg: 'bg-gray-500/10'   },
};

export const generateIncidentId = (): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const rand = Array.from({length:8}, () => chars[Math.floor(Math.random()*chars.length)]).join('');
  return `INC-${rand}`;
};

export const generateOfficerId = (): string =>
  `OFF-${Math.floor(10000 + Math.random() * 89999)}`;
